import { useContext } from "react";
import { AppContext } from "../context/AppContext";

export function usePermission(page: string, type: "add" | "edit" | "delete" | "view"): boolean {
  const ctx = useContext(AppContext) as any;
  const user = ctx?.user || ctx?.currentUser;
  if (!user) return false;
  if (user.role === "admin") return true;
  const perms = typeof user.permissions === "string"
    ? JSON.parse(user.permissions || "{}")
    : user.permissions || {};
  return !!perms?.[page]?.[type];
}